<template>
  <div v-loading="loading">
    <el-tag
      v-for="item in items"
      :key="item.groupId"
      size="medium"
      type="success"
      effect="plain"
      @click="selectitem(item)">
      {{ item.groupName }}
    </el-tag>
  </div>
</template>

<script>
export default {
  name: 'IntegralTask',
  props: {
    linkType: {
      type: Number,
      default: -1
    }
  },
  data() {
    return {
      loading: false,
      items: []
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    selectitem(item) {
      this.$emit('select', {
        linkType: this.linkType,
        link: item.groupId,
        title: item.groupName
      })
    },
    fetchList() {
      this.loading = true
      this.$store.dispatch('productgroup/getgroups', {
        payload: {
          pageNum: 1,
          pageSize: 10000,
          groupId: 0
        },
        success: res => {
          this.loading = false
          this.items = res.data.records
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style>

</style>
